import { Component, OnInit } from '@angular/core';
import { PosService } from 'src/app/lazy/private/services/pos.service';
import { MainService } from 'src/app/services/main.service';
import { DialogService } from '../dialog/dialog.service';
import { DialogComponent } from '../dialog/dialog.component';

export interface PopUpModel {
  title: string;
  data: any;
}

@Component({
  selector: 'app-discount',
  templateUrl: './discount.component.html',
  styleUrls: ['./discount.component.css']
})

export class DiscountComponent extends DialogComponent<PopUpModel, boolean>
  implements PopUpModel, OnInit {

  title: string;
  data: any ;
  result: any = { result: false, RtnItem: {} };
  preDiscount: any;
  sm_Name: string;
  selected_Discount: any = { Id: 0 };

  constructor(public dialogService: DialogService, private pos: PosService, private ms: MainService) {
    super(dialogService);
   }
 
  ngOnInit() {
   this.getDiscount();
  }

  getDiscount(){
    this.pos.GetPredefinedDiscount({ Id: this.ms.getSettings().LocId }).subscribe(res => {
      if (res.Success) {
        this.preDiscount = res.data;
        const d = this.data;
        if (d && d.Id !== 0) {
          let f = this.preDiscount.find(x => x.Id == d.PredefinedDiscId);
          this.selected_Discount=f;
          this.enter_Ok()
        }
      }
    });
  }

  enter_Ok() {
    if (this.selected_Discount.Id != 0) {
      this.result.result = true;
      this.result.RtnItem = this.selected_Discount;
      this.close();
    }
  }
  selectDiscount(i) {
    this.selected_Discount = i;
  }
}
